import type { ActivityModule } from '../../core/activity';
import { mountLearnDecimals } from './ui';
import levelsData from './levels.json';
import './style.css';

export const learnDecimals: ActivityModule = {
  id: 'learn_decimals',
  title: 'Aprenda os decimais',
  description: 'Pinte os décimos nas barras pra representar o número decimal pedido.',
  ageMin: 8,
  ageMax: 11,
  difficulty: 5,
  iconPath: 'assets/gcompris-AGPL/learn_decimals/icon.svg',
  category: 'numeracao',
  totalLevels: levelsData.levels.length,
  mount: mountLearnDecimals,
};
